module.exports = __webpack_public_path__ + "img/qrCode.e6760bce.png";